class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.clearInputButton = this.querySelector('.search__button-clear');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.loader = this.querySelector('.predictive-search__loader');
    this.suggestions = this.querySelector('.search-modal__suggestions');
    this.searchForm = this.querySelector(".search-modal__form");
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.clearInputButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.input.value = "";
      this.input.focus();
      this.close();
    });

  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.loaderShow();

    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          this.loaderHide();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        const searchItems = this.predictiveSearchResults.querySelectorAll(".predictive-search__list-item");

        this.noResults = this.querySelector('#predictive-search__no-results');

        this.searchForButton = this.predictiveSearchResults.querySelector("#button__search-for")?.addEventListener("click", this.search.bind(this));

        if(searchItems.length > 0) {
          this.suggestions?.classList.add('hidden');
        } else {
          if(this.input.value.trim().length === 0) {
            this.suggestions?.classList.remove('hidden');
          }
          
        }
       
        this.loaderHide();
        this.open();
      })
      .catch((error) => {
        this.close();
        this.loaderHide();
        throw error;
      });
  }

  onNoResults() {
    this.suggestionsShow();
    this.noResults.classList.remove('hidden');
    this.searchForButton.classList.add('hidden');
  }

  onHasResults() {
    this.suggestionsHide();
    this.noResults.classList.add('hidden');
    this.searchForButton.classList.remove('hidden');
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.suggestions?.classList.remove('hidden');
    this.predictiveSearchResults.style.display = 'none';
  }

  loaderShow() {
    this.loader.classList.remove('hidden');
  }

  loaderHide() {
    this.loader.classList.add('hidden');
  }

  suggestionsShow() {
    this.suggestions?.classList.remove('hidden');
  }

  suggestionsHide() {
    this.suggestions?.classList.add('hidden');
  }

  search() {
    this.searchForm.submit();
  }
}

customElements.define('predictive-search', PredictiveSearch);